import Vue from "vue";
import "./plugins/axios";
import "./plugins/axiosAdmin";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import plugin from "./plugins/index";
import "./plugins/element.js";
import "./assets/css/common.css";
import "./assets/icon/iconfont.css";

import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";

Vue.use(plugin).use(ViewUI);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
